// src/utils/serviceIcons.js
import GlobeIcon from "@mui/icons-material/Language";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import PaletteIcon from "@mui/icons-material/Palette";
import DatabaseIcon from "@mui/icons-material/Storage";
import CloudIcon from "@mui/icons-material/Cloud";
import ShieldIcon from "@mui/icons-material/Shield";
import CodeIcon from "@mui/icons-material/Code";
import ZapIcon from "@mui/icons-material/FlashOn";
import SettingsIcon from "@mui/icons-material/Settings";
import LayersIcon from "@mui/icons-material/Layers";
import MonitorIcon from "@mui/icons-material/Monitor";
import ServerIcon from "@mui/icons-material/Dns";
import BrushIcon from "@mui/icons-material/Brush";
import BugReportIcon from "@mui/icons-material/BugReport";
import SecurityIcon from "@mui/icons-material/Security";
import SpeedIcon from "@mui/icons-material/Speed";
import TrophyIcon from "@mui/icons-material/EmojiEvents";
import CheckIcon from "@mui/icons-material/TaskAlt";
import PeopleIcon from "@mui/icons-material/Groups";

const ICON_MAP = {
  Globe: GlobeIcon,
  Smartphone: SmartphoneIcon,
  Palette: PaletteIcon,
  Database: DatabaseIcon,
  Cloud: CloudIcon,
  Shield: ShieldIcon,
  Code: CodeIcon,
  Zap: ZapIcon,
  Settings: SettingsIcon,
  Layers: LayersIcon,
  Monitor: MonitorIcon,
  Server: ServerIcon,
  Brush: BrushIcon,
  BugReport: BugReportIcon,
  Security: SecurityIcon,
  Speed: SpeedIcon,
  Trophy: TrophyIcon,
  Check: CheckIcon,
  People: PeopleIcon,
};

export default ICON_MAP;